import { Opportunity } from 'types/opportunity';

const getOpportunityPrice = (opportunity: Opportunity) => opportunity?.finalCondition?.offerAmount ?? opportunity.redemption.budget;

export { getOpportunityPrice };
